export const SPACE_ID_STUDIO = "STUDIO_SPACE";
export const SPACE_ID_FLEX_WORKSPACE = "FLEX_SPACE";
export const SPACE_ID_MEETING_ROOM = "MEETING_SPACE";
export const SPACE_ID_MAAK = "MAAK_SPACE";
export const SPACE_ID_KITCHEN = "KITCHEN_SPACE";
export const SPACE_ID_RADIO = "RADIO_SPACE";

// De Multi en De Maak worden per dagdeel geboekt en delen daarom het
// uitgebreide aanvraagformulier; Flex en Studio blijven een losse aanvraag.
export const BOOKING_FLOW_SPACE_IDS = [SPACE_ID_MEETING_ROOM, SPACE_ID_MAAK];

// Ruimtes die je in één aanvraag kunt combineren. `extras` bepaalt welke
// extra opties onder de ruimtekeuze verschijnen; bij meerdere ruimtes wordt
// de samenvoeging getoond.
export const BOOKABLE_SPACE_OPTIONS = [
  {
    value: SPACE_ID_MEETING_ROOM,
    labelKey: "booking.space_multi",
    metaKey: "booking.space_multi_meta",
    extras: [
      "sound_set",
      "beamer_screen",
      "lighting",
      "dj_set",
      "extra_furniture",
      "tech_support",
      "dressing_room",
    ],
  },
  {
    value: SPACE_ID_MAAK,
    labelKey: "booking.space_maak",
    metaKey: "booking.space_maak_meta",
    extras: [
      "beamer_screen",
      "flipover",
      "meeting_set",
      "speakers",
      "extra_furniture",
    ],
  },
  {
    value: SPACE_ID_FLEX_WORKSPACE,
    labelKey: "booking.space_flex",
    metaKey: "booking.space_flex_meta",
    extras: [],
  },
  {
    value: SPACE_ID_KITCHEN,
    labelKey: "booking.space_kitchen",
    metaKey: "booking.space_kitchen_meta",
    extras: [],
  },
  {
    value: SPACE_ID_RADIO,
    labelKey: "booking.space_radio",
    metaKey: "booking.space_radio_meta",
    extras: ["tech_support"],
  },
];

// Volgorde waarin de extra opties getoond worden.
export const EXTRA_OPTION_ORDER = [
  "sound_set",
  "speakers",
  "beamer_screen",
  "flipover",
  "meeting_set",
  "lighting",
  "dj_set",
  "extra_furniture",
  "dressing_room",
  "tech_support",
];

export const getExtrasForSpaces = (spaceIds = []) =>
  EXTRA_OPTION_ORDER.filter((extra) =>
    BOOKABLE_SPACE_OPTIONS.some(
      (option) =>
        spaceIds.includes(option.value) && option.extras.includes(extra),
    ),
  );

export const MEETING_TYPE_OTHER = "other";

export const MEETING_TYPE_OPTIONS = [
  "workshop",
  "meeting",
  "presentation",
  "brainstorm",
  "lesson_series",
  "rehearsal",
  "recording",
  "exhibition",
  "performance",
  "company_outing",
  MEETING_TYPE_OTHER,
];
